import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Institution = () => {
  const [formData, setFormData] = useState({
    institutionName: '',
    ownerName: '',
    ownerPhoneNumber: '',
    // trainerName: '',
    district: '',
    taluka: '',
    institutionType: '',
    Signature_Photo: null, 
    password: '',
    referralid: localStorage.getItem('UserId'),
    RetypePassword: '',
  });
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
   
     useEffect(() => {
        // Fetch Districts from API
        fetch(`${process.env.REACT_APP_API}/locations/districts`)
          .then((res) => res.json())
          .then((data) => setDistricts(data))
          .catch((err) => console.error("Error fetching districts:", err));
      }, []);
    
      useEffect(() => {
        const selectedDistrict = districts.find(d => d.name === formData.district);
      
        if (selectedDistrict?.id) {
          fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
            .then((res) => res.json())
            .then((data) => setTalukas(data))
            .catch((err) => console.error("Error fetching taluks:", err));
        } else {
          setTalukas([]);
        }
      }, [formData.district, districts]); 
      

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (formData.password !== formData.RetypePassword) {
    setErrorMessage('Passwords do not match.');
    return;
  }

  if (formData.ownerPhoneNumber.length !== 10) {
    setErrorMessage('Phone number should be exactly 10 digits');
    return;
  }

  const viewPass = false;

  const submissionData = new FormData();
  submissionData.append('institutionName', formData.institutionName);
  submissionData.append('ownerName', formData.ownerName);
  submissionData.append('ownerPhoneNumber', formData.ownerPhoneNumber);
  submissionData.append('district', formData.district);
  submissionData.append('taluka', formData.taluka);
  submissionData.append('institutionType', formData.institutionType);
  submissionData.append('Signature_Photo', formData.Signature_Photo);
  submissionData.append('password', formData.password);
  submissionData.append('RetypePassword', formData.RetypePassword);
  submissionData.append('referralid', formData.referralid);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/instituteform/addinstitution`,
      submissionData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    alert('Form submitted successfully!');
    setFormData({
      institutionName: '',
      ownerName: '',
      ownerPhoneNumber: '',
      district: '',
      taluka: '',
      institutionType: '',
      Signature_Photo: null,
      password: '',
      RetypePassword: '',
      referralid: localStorage.getItem('UserId'),
    });
    setErrorMessage('');
    setSuccessMessage('Form submitted successfully!');
  } catch (error) {
    setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
    setSuccessMessage('');
  }
};

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const navi = useNavigate();
  const [add,setAdd] = useState(false)
  const [getData, setgetData] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(true);  // State to track loading
  const [error, setError] = useState(''); // State to track error
  const [selectedItem, setSelectedItem] = useState(null);
  const [editData, setEditData] = useState({
   
  });
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [isEditing, setIsEditing] = useState(false); 

  const handleAdd = () => {
    navi('/institutionform'); // Navigate to the admin form page
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/showinstitute/getinstitution`);
      setgetData(response.data);
    } catch (err) {
      setError('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleView = async (id) => {
    try {
        const viewdata = await axios.get(`${process.env.REACT_APP_API}/showdetails/viewinstitution/${id}`);
        setSelectedItem(viewdata.data);
        setIsEditing(false);
        setShowModal(true);
    } catch (err) {
        console.error(err);
    }
};

  const handleEdit = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/showdetails/viewinstitution/${id}`);
      const data = response.data;
      setEditData({
        institutionName:data.institutionName,
        ownerName: data.ownerName,
        phoneNumber:data.phoneNumber,
        trainerName: data.trainerName,
        district: data.District,
        taluka:data.taluka,
        institutionType:data.institutionType,
      });
      setSelectedItem(data);
      setIsEditing(true);
      setShowModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload on form submission
    try {
        // Sending PUT request to update the institution
        await axios.put(`${process.env.REACT_APP_API}/updateinstitution/editinstitution/${selectedItem.id}`, editData);
        alert('Data updated successfully!');
        setShowModal(false); // Close the modal after successful update
        fetchData(); // Refetch data to reflect updated values in the table
    } catch (err) {
        console.error(err);
        alert('Failed to update data!');
    }
};


  const handleCloseModal = () => {
    setShowModal(false);
  };


  const handleEditChange = (e) => {
    const { name, value } = e.target;
  
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // If district changes, update Taluka options dynamically
    if (name === "district") {
      const selectedDistrict = districts.find((d) => d.name === value);
  
      if (selectedDistrict?.id) {
        fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
          .then((res) => res.json())
          .then((data) => {
            setTalukas(data);
            setEditData((prev) => ({ ...prev, taluka: "" })); // Reset Taluka field
          })
          .catch((err) => {
            console.error("Error fetching talukas:", err);
            // setTalukas([]);
          });
      } else {
        setTalukas([]);
        setEditData((prev) => ({ ...prev,taluka: "" })); // Reset Taluka field
      }
    }
  };
  
  
  const [search, setSearch] = useState("");

// Filter getData based on the search input (by username)
const filteredData = getData.filter((item) =>
  item.institutionName?.toLowerCase().includes(search.trim().toLowerCase())
);
  return (
    <div>
      <div style={{ marginBottom: '50px' }}>
        <Link to="/" className="logo_image">
          <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
        </Link>
      </div>


      <div style={{ overflowX: 'auto' }} className='tablecontainer'>
        
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by username..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="add-btn"
         onClick={()=>setAdd(!add)}
        // onClick={handleAdd}
        >
          + Add
        </button>
      </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          <table >
            <thead >
              <tr>
                <th ><h5>S.No</h5></th>
                <th ><h5>Institution Name</h5></th>
                <th ><h5>Phone Number</h5></th>
                <th ><h5>District</h5></th>
                <th ><h5>Taluka</h5></th>
                <th ><h5>Institution Type</h5></th>
                <th ><h5>View</h5></th>
                <th ><h5>Edit</h5></th>
              </tr>
            </thead>
            <tbody>
            {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.institutionName}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.District}</td>
                    <td>{item.taluka}</td>
                    <td>{item.institutionType}</td>
                    <td><button onClick={() => handleView(item.id)}>View</button></td>
                    <td><button onClick={() => handleEdit(item.id)}>Edit</button></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

 
    
{showModal && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      minWidth: '100vw',
      width: '100%',
    }}
    onClick={handleCloseModal}
  >
    <div
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        width: '400px',
        minHeight: '200px',
        overflowY: 'auto',
        position: 'relative',
      }}
      onClick={(e) => e.stopPropagation()}
    >
 {isEditing ? (
  <>
    <h3>Edit Details</h3>
    <form onSubmit={handleEditSubmit} style={{ overflowY: 'auto' }}>
      <label>Institution Name:</label>
      <input
        type="text"
        name="institutionName"
        placeholder="Institution Name"
        value={editData.institutionName}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      />

      <label>Owner Name:</label>
      <input
        type="text"
        name="ownerName"
        placeholder="Owner Name"
        value={editData.ownerName}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      />

      <label>Phone Number:</label>
      <input
        type="text"
        name="phoneNumber"
        placeholder="Phone Number"
        value={editData.phoneNumber}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      />

      {/* <label>Trainer Name:</label>
      <input
        type="text"
        name="trainerName"
        placeholder="Trainer Name"
        value={editData.trainerName}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      /> */}

      <label>District:</label>
      <select
        name="district"
        value={editData.district}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      >
        <option value="">Select District</option>
        {districts.map((district) => (
          <option key={district.id} value={district.name}>
            {district.name}
          </option>
        ))}
      </select>

      <label>Taluka:</label>
      <select
        name="taluka"
        value={editData.taluka} // This will pre-select the Taluka based on the value in editData.taluka
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      >
        <option value="">Select Taluka</option>
        {talukas.map((taluk) => (
          <option key={taluk.id} value={taluk.name}>
            {taluk.name}
          </option>
        ))}
      </select>

      <label>Institution Type:</label>
      <input
        type="text"
        name="institutionType"
        placeholder="Institution Type"
        value={editData.institutionType}
        onChange={handleEditChange}
        style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
        <button type="button" onClick={handleCloseModal} style={{ backgroundColor: 'red', color: 'white' }}>
          Cancel
        </button>
        <button type="submit" style={{ backgroundColor: 'blueviolet', color: 'white' }}>
          Update
        </button>
      </div>
    </form>
  </>
) : (
  <div>
    <h3>View Details</h3>
    <p><strong>Institution Name:</strong> {selectedItem?.institutionName}</p>
    <p><strong> UserId :</strong> {selectedItem?.UserId}</p>
    <p><strong> password :</strong> {selectedItem?.viewpass}</p>
    <p><strong>Owner Name:</strong> {selectedItem?.ownerName}</p>
    <p><strong>Phone Number:</strong> {selectedItem?.phoneNumber}</p>
    <p><strong>Trainer Name:</strong> {selectedItem?.trainerName}</p>
    <p><strong>District:</strong> {selectedItem?.district}</p>
    <p><strong>Taluka:</strong> {selectedItem?.taluka}</p>  {/* Display the selected Taluka */}
    <p><strong>Institution Type:</strong> {selectedItem?.institutionType}</p>
    <p><strong>Signature Photo :</strong> </p>
    <div>
  <img
    src={`${process.env.REACT_APP_API}/uploads/institution/${selectedItem?.Signature_Photo}`}
    alt="Institution Signature"
    style={{ width: '150px', height: 'auto' }} // Optional styling
    
  />
</div>


    <button
      onClick={handleCloseModal}
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'red',
        color: 'white',
        border: 'none',
        padding: '5px 10px',
        cursor: 'pointer',
      }}
    >
      Close
    </button>
  </div>
)}

    </div>
  </div>
)}


      {add && (
        <>
        
 <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
      <div   
       style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        width: '400px',
        minHeight: '200px',
        overflowY: 'auto',
        position: 'relative',
        // overflow:"hidden"
      }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <input
            type="text"
            id="institutionName"
            placeholder="Institution Name"
            value={formData.institutionName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          />

          <input
            type="text"
            id="ownerName"
            placeholder="Owner Name"
            value={formData.ownerName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          />

          <input
            type="tel"
            id="ownerPhoneNumber"
            placeholder="Owner Phone Number"
            maxLength={10}
            value={formData.ownerPhoneNumber}
            onChange={(e) => {
              const newValue = e.target.value.replace(/[^0-9]/g, ''); 
              setFormData((prevData) => ({
                ...prevData,
                ownerPhoneNumber: newValue,
              }));
            }}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          />

          {/* <input
            type="text"
            id="trainerName"
            placeholder="Trainer Name"
            value={formData.trainerName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          /> */}

          <select
            id="district"
            value={formData.district}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          >
             <option value="">Select District</option>
          {districts.map((district) => (
            <option key={district.id} value={district.name}>
              {district.name}
            </option>
          ))}
          </select>

          <select
            id="taluka"
            value={formData.taluka}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          >
             <option value="">Select Taluk</option>
             {talukas.map((taluk) => ( // ✅ Corrected from `taluka.map` to `talukas.map`
          <option key={taluk.id} value={taluk.name}>
            {taluk.name}
          </option>
        ))}
          </select>

          <select
            id="institutionType"
            value={formData.institutionType}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          >
            <option value="">Select Institution Type</option>
            <option value="Computer Education">Computer Education</option>
            <option value="Beautician Course">Beautician Course</option>
            <option value="Tailoring Institution">Tailoring Institution</option>
          </select>
          <h6 style={{justifyContent:"start",width:"100%"}}><label htmlFor="signature">Signature Photo:</label></h6>
           
           <input
  type="file"
  accept="image/*"
  className="meeting-input"
  required
  style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
  onChange={(e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        Signature_Photo: file,
      }));
    }
  }}
/>


          <input
            type="password"
            id="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          />

          <input
            type="password"
            id="RetypePassword"
            placeholder="Retype Password"
            value={formData.RetypePassword}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '100%' }}
          />

          <div style={{display:'flex',width:"100%", justifyContent:'space-between',alignItems:"center"}}>
          <button
            type="submit"
            style={{
              padding: '10px 20px',
              backgroundColor: '#007BFF',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              width: '30%',
              borderRadius: '10px',
            }}
          >
            Submit
          </button>
          <button 
             style={{
              padding: '10px 20px',
              backgroundColor: 'red',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              width: '30%',
              borderRadius: '10px',
            }}
          onClick={()=>setAdd(!add)}>
            close 
          </button>

          </div>
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
        </form>
      </div>
      </div>

      
    </div>
        </>
      )}
    </div>
  );
};

export default Institution;
